import { useTranslate } from 'react-admin';
import { Card, Box, Typography } from '@mui/material';
import { AboutSectionPart } from './AboutSectionPart';


const blobStorage = 'https://estatetime.blob.core.windows.net/root/web/about/';


const aboutSections = [
  {
    content: `${blobStorage}6.mp4`,
    title: 'Who We Are',
    description: 'We are a team of dedicated data enthusiasts, real estate experts, and tech innovators. Our diverse backgrounds and expertise come together to create a tool that is not only powerful but also user-friendly. We believe that informed decisions lead to better outcomes, and we are committed to empowering you with the data you need to make those decisions.',
  },
  {
    content: `${blobStorage}2.mp4`,
    title: 'Easily Map The Most Relevant Attributes',
    description: 'Access exclusive Single Family Homes Sales and Rental Data. Easily map the most relevant statistical data to analyze historical changes in real estate sales and identify next investment opportunities.',
  },
  {
    content: `${blobStorage}3.mp4`,
    title: 'Our Mission',
    description: 'Our mission is simple: to democratize access to real estate data and make it understandable and actionable for everyone. We strive to bridge the gap between complex data and everyday users, enabling you to make smarter, data-driven decisions.',
  },
  {
    content: `${blobStorage}4.mp4`,
    title: 'Why Choose My Real Stat?',
    description: 'Accuracy: Our data is meticulously collected and updated every month to ensure you have the latest information at your fingertips. ' +
      'Comprehensive: We cover a wide range of metrics, offering a holistic view of the real estate market. ' +
      'User-Friendly: Our intuitive interface makes navigating through data and insights a breeze. ' +
      'Expertise: Our team is always here to support you, with expert advice and customer service.',
  },
  {
    content: `${blobStorage}5.mp4`,
    title: 'Join Us',
    description: 'We invite you to join the My Real Stat community and experience the difference that accurate, actionable data can make. Together, we can make smarter real estate decisions and achieve better outcomes.',
  },
  {
    content: `${blobStorage}1.mp4`,
    title: 'Houston Edition & What\'s Next',
    description: 'My Real Stat is currently focused on the Houston metropolitan area, providing you with the most comprehensive and up-to-date real estate data for Houston. Stay tuned—other major metropolitan areas are coming soon as we expand our coverage to help even more communities make smarter real estate decisions!',
  },
];

export const AboutPage = () => {
  const translate = useTranslate();

  return (
    <Card sx={{ p: 8 }}>
      <Box display="flex" maxWidth={'100%'} flexDirection='column' gap={1} justifyContent='center' alignItems='center'>
        <Typography sx={styles.pageTitleIntro}>
          {'This is our story'}
        </Typography>
        <Typography sx={styles.pageTitle} gutterBottom>
          {'Welcome to My Real Stat'}
        </Typography>
        <Typography sx={styles.sectionTitle} maxWidth={800}>
          {'At My Real Stat, we are revolutionizing the way you interact with real estate data. Our program is designed with one goal in mind: to provide you with the most accurate, up-to-date, and comprehensive real estate statistics available.'}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 4 }}>
        {aboutSections.map((section, index) => (
          <AboutSectionPart
            key={index}
            image={section.content}
            title={section.title}
            description={section.description}
            position={index % 2 === 0 ? 'left' : 'right'}
          />
        ))}
      </Box>
    </Card>
  );
};

const styles = {
  pageTitleIntro: { 
    typography: 'body2', 
    textAlign: 'center',
  },
  pageTitle: { typography: 'h3' },
  sectionTitle: { 
    typography: 'body1',
    textAlign: 'center'
  },
};